<div #sidebar class="side-navigation">
    <ul class="nav-list">
        @for (item of navigation; track item) {
            <app-item-nav [item]="item" [scrolling]="scrolling$ | async" />
        }
    </ul>
</div>
